import { ReactNode } from "react";
import { CommentDto } from "../api/Api";
import { msalInstance } from "../authconfig";

export const getCurrentCommentAuthor = () => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  return account?.username || account?.name || "Unknown";
};

export const getCurrentCommentAuthorName = () => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  return account?.name || account?.username || "Unknown";
};

export const buildCommentDto = (comment: string): CommentDto => ({
  author: getCurrentCommentAuthor(),
  authorName: getCurrentCommentAuthorName(),
  comment,
  timestamp: new Date().toISOString()
});

// Render a stored comment (which may embed @[Display Name](email) mention markup)
// as a mix of plain-text spans and highlighted @Display Name spans. Plain comments
// pass through unchanged.
const MENTION_RE = /@\[([^\]]+)\]\(([^)]+)\)/g;

export const renderCommentText = (
  comment: string,
  renderMention: (display: string, email: string, key: string) => ReactNode
): ReactNode[] => {
  if (!comment) {
    return [];
  }
  const parts: ReactNode[] = [];
  let cursor = 0;
  let index = 0;
  MENTION_RE.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = MENTION_RE.exec(comment)) !== null) {
    if (match.index > cursor) {
      parts.push(comment.slice(cursor, match.index));
    }
    parts.push(renderMention(match[1], match[2], `m-${index}`));
    cursor = match.index + match[0].length;
    index += 1;
  }
  if (cursor < comment.length) {
    parts.push(comment.slice(cursor));
  }
  return parts;
};
